import React from 'react';

const FooterNavigation = () => (
    <nav>
        <ul>
            <li>
                <a href="https://www.nhl.com/info/privacy-policy" target="_blank">Privacy Policy</a>
            </li>
            <li>
                <a href="https://www.nhl.com/info/cookie-policy" target="_blank">Cookie Policy</a>
            </li>
            <li>
                <a href="https://www.nhl.com/info/copyright-policy" target="_blank">Copyright Policy</a>
            </li>
            <li>
                <a href="https://www.nhl.com/info/terms-of-service" target="_blank">Terms of Service</a>
            </li>
            <li>
                <a href="https://www.nhl.com/info/your-privacy-choices" target="_blank">Your Privacy Choices</a>
            </li>
            <li>
                <a href="https://www.nhl.com/cba/" target="_blank">CBA</a>
            </li>
        </ul>
    </nav>
);

export default FooterNavigation;
